import api from "api";
import _ from "lodash";
import React, {useContext} from "react";
import { useEffect } from "react";
import { useState } from "react";
import stateMap from "store/stateMap";
import { connect } from 'react-redux';
import BlockHeader from "component/BlockHeader/BlockHeader";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import {  InitiativeListGrouped } from "component/InitiativeList";
import { RatingCardList, RatingInitiativeCardList } from "component/Rating";
import "../../../../sass/tab/tab.scss";
import { UserContext } from "..";
import { PageCredential } from "component/PageCredential";


const PageProfileUserActivity = connect(stateMap)((props) => {
    const [displayedRating, setDisplayedRating]     = useState('received');
    const currentUserContext                        = useContext(UserContext);
    const [profileInterest, setProfileInterest]     = useState(false);
    
    useEffect(() => {
        if(!props.auth.user)
        {
            return;
        }

        if(!currentUserContext.profile)
        {
            return;
        }

        api('/Profile/Interest', 'get', {
            user_id : currentUserContext.profile.UserID
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                setProfileInterest(response.interest)
            })

    }, [currentUserContext.profile, props.auth.user]);

    console.log('ddd',currentUserContext);
    
    return (
        currentUserContext.profile &&
        <div className="page-profile-user page-profile">
            <PageCredential title={`${currentUserContext.profile.UserDisplayName} | Activity`}/>
            <div className="container">
                <BlockHeader title="Involved Initiatives"/>
                <InitiativeListGrouped
                    list_args={{
                        member_id : currentUserContext.profile.UserID
                    }}
                />
            </div>
            <div className="user-ratings-container">
                <div className="container" >
                    <BlockHeader title="Rating &amp; Testimonial"/>
                    <div className="user-ratings-block">
                        <div className="tabs">
                            <Splide options={{
                                autoWidth : true
                                ,pagination : false
                                ,arrows : false
                            }}>
                                <SplideSlide>
                                    <div className={`tab ${displayedRating == 'received' && 'active'}`} onClick={(e) => {
                                        e.preventDefault();
                                        setDisplayedRating('received');
                                    }}>
                                        <a href="#" className="tab-wrapper">Rating</a>
                                    </div>
                                </SplideSlide>
                                <SplideSlide>
                                    <div className={`tab ${displayedRating == 'testimonial' && 'active'}`} onClick={(e) => {
                                        e.preventDefault();
                                        setDisplayedRating('testimonial');
                                    }}>
                                        <a href="#" className="tab-wrapper">Testimonial</a>
                                    </div>
                                </SplideSlide>
                            </Splide>
                        </div>
                        <div className="user-ratings-data">
                            {
                                displayedRating == 'received' && 
                                <RatingInitiativeCardList listArgs={{
                                    user_id : currentUserContext.profile.UserID
                                    ,posts_per_page : 5
                                }}/>
                            }
                            {
                                displayedRating == 'testimonial' && 
                                <RatingCardList listArgs={{
                                    user_id : currentUserContext.profile.UserID
                                    ,posts_per_page : 5
                                    ,has_message : 1
                                }} userToDisplay="Sender_"/>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <BlockHeader title="Interest"/>
                <div className="interests-list-container">
                    <ul className="interests-lists">
                        {
                            profileInterest !== false && profileInterest.map((interest) => {
                                return (
                                    <li className="interest" key={interest.InterestID}>
                                        <span className="block wrapper" style={{
                                                backgroundImage : 'url('+interest.AttachmentURL+')' 
                                                ,cursor : 'default'
                                            }}>
                                            <span className="relative">
                                                {interest.InterestName}
                                            </span>
                                        </span>
                                    </li>
                                )
                            })
                        }
                        {
                            profileInterest === false &&
                            <li className="interest skeleton-interest">                                
                                <span className="skeleton"></span>
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
});

export default PageProfileUserActivity;